import { useEffect } from 'react';
import { getFocusOnState } from '@components/MainStage/focusOn.store';
import { isEditableTextTarget } from '@utils/isEditableTextTarget';

const useFocusExitShortcut = () => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape') return;

      if (isEditableTextTarget(document.activeElement)) return;

      if (getFocusOnState().sourceId === null) return;

      getFocusOnState().clear();
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useFocusExitShortcut;
